import { toBase64, alertSwal, htmlToBase64Picture } from '~/utils/helpers';
import cloneDeep from 'lodash/cloneDeep';
import { IMAGE_WITH_IN_PIXEL, IMAGE_HEIGHT_IN_PIXEL } from '~/config/constants';

export class RequestBodyConverter {
    constructor(values) {
        this.values = cloneDeep(values);
    }

    async convertAllPictures(values, allPictures) {
        try {
            await Promise.all(
                allPictures.map(async (item) => {
                    if (item.includes('.')) {
                        const [template, pic] = item.split('.');
                        this.values[template][pic] = await toBase64(values[template][pic]);
                    } else {
                        this.values[item] = await toBase64(values[item]);
                    }
                }),
            );
        } catch (error) {
            alertSwal('error', 'There was error in processing card image.');
            console.log('🚀 ~ error:::RequestBodyConverter convertAllPictures()', error);
            throw error;
        }
    }

    async convertAllPicturesWithoutCardMaker(values, allPictures) {
        try {
            await Promise.all(allPictures.map(async (item) => (this.values[item] = await toBase64(values[item]))));
        } catch (error) {
            alertSwal('error', 'There was error in processing card image.');
            console.log('🚀 ~ error:::RequestBodyConverter convertAllPicturesWithoutCardMaker()', error);
        }
    }

    async createImageAsBase64String(element) {
        try {
            const base64String = await htmlToBase64Picture(element, IMAGE_WITH_IN_PIXEL, IMAGE_HEIGHT_IN_PIXEL);
            this.values.image = base64String;
        } catch (error) {
            console.log('🚀 ~ error:', error);
            alertSwal('error:::RequestBodyConverter createImageAsBase64String()', `Cannot export picture: ${error}.`);
        }
    }

    getValues() {
        return this.values;
    }
}
